// // New utility: GenerateVendorBreakdownPDF.js
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// /**
//  * GenerateVendorBreakdownPDF
//  * @param {string} selectedProperty
//  * @param {Array<object>} rooms - array of room objects (expects displayName, status, id, and itemCount* keys)
//  * @param {(msg: string) => void} setStatusMessage
//  * @param {{ fullName: string }} user
//  * @param {string} fileName - shown as the document title
//  * @param {Array<object>} items - array of item config objects:
//  *   {
//  *     itemCost: "700",
//  *     itemDifficulty:"25",
//  *     itemGLCode:"60908",
//  *     itemID:"itemCountACUnit",
//  *     itemName:"AC Unit",
//  *     itemResponsibility:"Maintenance",
//  *     itemSKU:"1",
//  *     itemType:"Appliances",
//  *     vendor:"Home Depot"
//  *   }
//  */
// const GenerateVendorBreakdownPDF = async (
//   selectedProperty,
//   rooms,
//   setStatusMessage,
//   user,
//   fileName,
//   items
// ) => {
//   setStatusMessage?.("Initializing Vendor Breakdown PDF");

//   const pdf = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: "a4", // A4 keeps it printer-friendly; change if you prefer your custom size
//   });

//   const marginX = 12;
//   const pageWidth = pdf.internal.pageSize.getWidth();

//   // Helpers
//   const right = (txt, y) => {
//     const w = pdf.getTextWidth(String(txt));
//     pdf.text(String(txt), pageWidth - marginX - w, y);
//   };
//   const center = (txt, y) => {
//     const w = pdf.getTextWidth(String(txt));
//     pdf.text(String(txt), (pageWidth - w) / 2, y);
//   };
//   const currency = (n) => {
//     const v = Number.parseFloat(n || 0);
//     return isFinite(v) ? v : 0;
//   };
//   const fmtCurrency = (n) =>
//     new Intl.NumberFormat(undefined, {
//       style: "currency",
//       currency: "USD",
//     }).format(n);

//   // Header
//   pdf.setFont("helvetica", "bold");
//   pdf.setFontSize(18);
//   center(fileName || "Vendor Breakdown", 18);

//   pdf.setFont("helvetica", "normal");
//   pdf.setFontSize(10);
//   right(`Generated by ${user?.fullName || "Unknown"}`, 10);
//   right(`Date: ${new Date().toLocaleDateString()}`, 15);

//   // Work set: only Down rooms (consistent with previous generator)
//   const downRooms = (rooms || []).filter((r) => r?.status === "Down");

//   // Precompute: for each item, find total needed and the rooms that need it
//   // Map by vendor -> array of table rows
//   const byVendor = new Map();

//   for (const item of items || []) {
//     const {
//       itemID,
//       itemName,
//       itemGLCode,
//       itemCost,
//       vendor = "Unassigned Vendor",
//     } = item || {};

//     if (!itemID) continue; // cannot match without itemID

//     let totalNeeded = 0;
//     const neededFor = [];

//     for (const room of downRooms) {
//       // any key that exactly matches itemID (e.g., "itemCountACUnit")
//       const count = Number(room?.[itemID] || 0);
//       if (count > 0) {
//         totalNeeded += count;
//         neededFor.push(room.displayName || room.room || String(room.id || ""));
//       }
//     }

//     if (totalNeeded <= 0) continue; // skip items not needed anywhere

//     const vendorKey =
//       vendor && vendor.trim() ? vendor.trim() : "Unassigned Vendor";
//     if (!byVendor.has(vendorKey)) byVendor.set(vendorKey, []);

//     byVendor.get(vendorKey).push({
//       itemName: itemName || itemID,
//       itemCost: currency(itemCost),
//       itemGLCode: itemGLCode || "",
//       totalNeeded,
//       neededFor: neededFor.join(", "),
//     });
//   }

//   // For each vendor, render a table with a footer estimated total
//   let firstVendor = true;

//   for (const [vendorName, rows] of byVendor) {
//     // Sort rows by itemName for consistency
//     rows.sort((a, b) => a.itemName.localeCompare(b.itemName));

//     // Compute vendor subtotal
//     const vendorSubtotal = rows.reduce(
//       (sum, r) => sum + r.itemCost * r.totalNeeded,
//       0
//     );

//     if (!firstVendor) {
//       pdf.addPage();
//     }
//     firstVendor = false;

//     // Section header
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(14);
//     pdf.text(vendorName, marginX, 20);

//     // Table columns
//     const head = [
//       [
//         "Item",
//         "Estimated Cost",
//         "GL Code",
//         "Needed Total",
//         "Needed For (Rooms)",
//       ],
//     ];

//     const body = rows.map((r) => [
//       r.itemName,
//       fmtCurrency(r.itemCost),
//       r.itemGLCode,
//       String(r.totalNeeded),
//       r.neededFor,
//     ]);

//     // Render table
//     autoTable(pdf, {
//       head,
//       body,
//       startY: 26,
//       styles: {
//         font: "helvetica",
//         fontSize: 9,
//         cellPadding: 2.5,
//         overflow: "linebreak",
//       },
//       headStyles: {
//         fillColor: [230, 230, 230],
//         textColor: 20,
//         halign: "left",
//       },
//       columnStyles: {
//         0: { cellWidth: 40 }, // Item
//         1: { cellWidth: 30 }, // Estimated Cost
//         2: { cellWidth: 25 }, // GL Code
//         3: { cellWidth: 25, halign: "right" }, // Needed Total
//         4: { cellWidth: "auto" }, // Needed For
//       },
//       // Add a footer row with vendor estimated total
//       didDrawPage: (data) => {
//         // You can add page numbers here if desired
//       },
//       // Add a custom "summary row" after the table
//       didDrawCell: (data) => {
//         // no-op, reserved for custom cell drawing if needed later
//       },
//       margin: { left: marginX, right: marginX },
//     });

//     // After the table is drawn, write the vendor total beneath it
//     const afterTableY = pdf.lastAutoTable.finalY + 6;
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(11);
//     pdf.text(
//       `Estimated Total: ${fmtCurrency(vendorSubtotal)}`,
//       marginX,
//       afterTableY
//     );
//   }

//   // If there were no rows at all (no items matched), provide a friendly message
//   if (byVendor.size === 0) {
//     pdf.setFont("helvetica", "italic");
//     pdf.setFontSize(12);
//     pdf.text("No items with needs found for the selected rooms.", marginX, 40);
//   }

//   // Save
//   setStatusMessage?.("Finalizing PDF");
//   const today = new Date();
//   const date = today.toISOString().split("T")[0].replace(/-/g, "_");
//   const pdfBlob = pdf.output("blob");
//   const pdfUrl = URL.createObjectURL(pdfBlob);
//   const a = document.createElement("a");
//   a.href = pdfUrl;
//   a.download = `${(fileName || "Vendor_Breakdown").replace(
//     /\s+/g,
//     "_"
//   )}_${date}.pdf`;
//   a.click();
//   URL.revokeObjectURL(pdfUrl);
// };

// export default GenerateVendorBreakdownPDF;
// GenerateVendorBreakdownPDF.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * GenerateVendorBreakdownPDF
 * Cover page: Included Rooms + Vendor Summary (estimated totals per vendor)
 * Then: One AutoTable per vendor with item details and a vendor subtotal.
 *
 * @param {string} selectedProperty
 * @param {Array<object>} rooms
 * @param {(msg: string) => void} setStatusMessage
 * @param {{ fullName: string }} user
 * @param {string} fileName
 * @param {Array<object>} items - objects like:
 *   {
 *     itemCost: "700",
 *     itemDifficulty:"25",
 *     itemGLCode:"60908",
 *     itemID:"itemCountACUnit",
 *     itemName:"AC Unit",
 *     itemResponsibility:"Maintenance",
 *     itemSKU:"1",
 *     itemType:"Appliances",
 *     vendor:"Home Depot"
 *   }
 */
const GenerateVendorBreakdownPDF = async (
  selectedProperty,
  rooms,
  setStatusMessage,
  user,
  fileName,
  items
) => {
  setStatusMessage?.("Initializing Vendor Breakdown PDF");

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const marginX = 12;
  const pageWidth = pdf.internal.pageSize.getWidth();

  // Helpers
  const right = (txt, y) => {
    const s = String(txt ?? "");
    const w = pdf.getTextWidth(s);
    pdf.text(s, pageWidth - marginX - w, y);
  };
  const center = (txt, y) => {
    const s = String(txt ?? "");
    const w = pdf.getTextWidth(s);
    pdf.text(s, (pageWidth - w) / 2, y);
  };
  const currencyVal = (n) => {
    const v = Number.parseFloat(n ?? 0);
    return Number.isFinite(v) ? v : 0;
  };
  const fmtUSD = (n) =>
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "USD",
    }).format(n);

  // Header (cover page)
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  center(fileName || "Vendor Breakdown", 18);

  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);
  right(`Generated by ${user?.fullName || "Unknown"}`, 10);
  right(`Date: ${new Date().toLocaleDateString()}`, 15);

  // Filter out Occupied and Up rooms (they shouldn't need items)
  const selectedRooms = (rooms || []).filter((r) => r?.status !== "Occupied" && r?.status !== "Up");
  const roomNames = selectedRooms
    .map((r) => r?.displayName || r?.room || String(r?.id ?? ""))
    .filter(Boolean);

  // Build vendor -> rows and vendor subtotal maps
  const byVendor = new Map(); // vendor -> [{ itemName, itemCost, itemGLCode, totalNeeded, neededFor }]
  const vendorTotals = new Map(); // vendor -> subtotal number

  for (const item of items || []) {
    const vendor =
      (item?.vendor || "Unassigned Vendor").trim() || "Unassigned Vendor";
    const itemID = item?.itemID;
    if (!itemID) continue;

    let totalNeeded = 0;
    const neededFor = [];

    for (const room of selectedRooms) {
      const count = Number(room?.[itemID] || 0);
      if (count > 0) {
        totalNeeded += count;
        neededFor.push(
          room?.displayName || room?.room || String(room?.id ?? "")
        );
      }
    }
    if (totalNeeded <= 0) continue;

    const row = {
      itemName: item?.itemName || itemID,
      itemCost: currencyVal(item?.itemCost),
      itemGLCode: item?.itemGLCode || "",
      totalNeeded,
      neededFor: neededFor.join(", "),
    };

    if (!byVendor.has(vendor)) byVendor.set(vendor, []);
    byVendor.get(vendor).push(row);

    const add = row.itemCost * row.totalNeeded;
    vendorTotals.set(vendor, (vendorTotals.get(vendor) || 0) + add);
  }

  // ===== Cover page content =====
  // Included Rooms (wrapped paragraph)
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);
  pdf.text("Included Rooms", marginX, 28);

  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);
  const roomsText = roomNames.length ? roomNames.join(", ") : "None";
  const wrappedRooms = pdf.splitTextToSize(roomsText, pageWidth - marginX * 2);
  pdf.text(wrappedRooms, marginX, 34);

  // Compute where to place the "Vendor Summary" table after the rooms block
  const roomsBlockH = pdf.getTextDimensions(wrappedRooms).h || 0;
  const summaryStartY = 34 + roomsBlockH + 8;

  // Vendor Summary table (Vendor | Estimated Total)
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(12);
  pdf.text("Vendor Summary", marginX, summaryStartY - 4);

  const vendorSummaryRows = Array.from(vendorTotals.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([vendor, subtotal]) => [vendor, fmtUSD(subtotal)]);

  autoTable(pdf, {
    head: [["Vendor", "Estimated Total"]],
    body: vendorSummaryRows.length ? vendorSummaryRows : [["—", "—"]],
    startY: summaryStartY,
    styles: { font: "helvetica", fontSize: 10, cellPadding: 2.5 },
    headStyles: { fillColor: [230, 230, 230], textColor: 20, halign: "left" },
    columnStyles: {
      0: { cellWidth: 90 },
      1: { cellWidth: 40, halign: "right" },
    },
    margin: { left: marginX, right: marginX },
    theme: "grid",
  });

  // ===== Detail pages: one vendor per section =====
  const vendorsSorted = Array.from(byVendor.entries()).sort(([a], [b]) =>
    a.localeCompare(b)
  );

  if (vendorsSorted.length) {
    pdf.addPage();
  }

  let first = true;
  for (const [vendorName, rows] of vendorsSorted) {
    if (!first) pdf.addPage();
    first = false;

    // Sort rows by item name for consistency
    rows.sort((a, b) => a.itemName.localeCompare(b.itemName));

    // Header
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text(vendorName, marginX, 20);

    // Table
    const head = [
      [
        "Item",
        "Estimated Cost",
        "GL Code",
        "Needed Total",
        "Needed For (Rooms)",
      ],
    ];
    const body = rows.map((r) => [
      r.itemName,
      fmtUSD(r.itemCost),
      r.itemGLCode,
      String(r.totalNeeded),
      r.neededFor,
    ]);

    autoTable(pdf, {
      head,
      body,
      startY: 26,
      styles: {
        font: "helvetica",
        fontSize: 9,
        cellPadding: 2.5,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: 20,
        halign: "left",
      },
      columnStyles: {
        0: { cellWidth: 40 }, // Item
        1: { cellWidth: 30 }, // Estimated Cost
        2: { cellWidth: 25 }, // GL Code
        3: { cellWidth: 25, halign: "right" }, // Needed Total
        4: { cellWidth: "auto" }, // Needed For
      },
      margin: { left: marginX, right: marginX },
      theme: "grid",
    });

    // Vendor subtotal under the table
    const afterY = (pdf.lastAutoTable?.finalY || 26) + 6;
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(11);
    const subtotal = vendorTotals.get(vendorName) || 0;
    pdf.text(`Estimated Total: ${fmtUSD(subtotal)}`, marginX, afterY);
  }

  if (!vendorsSorted.length) {
    // No items matched -> friendly note on cover page
    const y = (pdf.lastAutoTable?.finalY || summaryStartY) + 10;
    pdf.setFont("helvetica", "italic");
    pdf.setFontSize(11);
    pdf.text("No items with needs found for the selected rooms.", marginX, y);
  }

  // Save
  setStatusMessage?.("Finalizing PDF");
  const today = new Date();
  const date = today.toISOString().split("T")[0].replace(/-/g, "_");
  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const a = document.createElement("a");
  a.href = pdfUrl;
  a.download = `${(fileName || "Vendor_Breakdown").replace(
    /\s+/g,
    "_"
  )}_${date}.pdf`;
  a.click();
  URL.revokeObjectURL(pdfUrl);
};

export default GenerateVendorBreakdownPDF;
